import React from 'react';

export const TermsAndConditionsPage = () => {
  return (
    <div className="min-h-screen pt-20 bg-white">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl py-16">
        <h1 className="text-4xl md:text-5xl font-heading font-bold text-brand-navy mb-8">
          Terms & Conditions
        </h1>
        
        <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
          <p>
            By accessing the <strong>US Brand Experts</strong> website (referred to as the "Site"), you acknowledge and accept the terms and conditions outlined herein, forming an agreement between you and US Brand Experts (referred to as "we," "us," or "our"). This agreement also incorporates our Privacy Policy as if fully stated here. If you do not agree with these terms, please refrain from using the Site. <strong>THIS AGREEMENT INCLUDES A MANDATORY ARBITRATION CLAUSE GOVERNED BY THE FEDERAL ARBITRATION ACT, AND A WAIVER OF CLASS ACTIONS.</strong>
          </p>

          <h2 className="text-2xl font-heading font-bold text-brand-navy mt-8 mb-4">
            Conditions for Use of the Site
          </h2>
          <p>Your access to and use of the Site is contingent upon your acceptance and adherence to these terms. By using the Site, you agree that you:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Will comply with these Terms of Service</li>
            <li>Are 18 years of age or older</li>
            <li>Will not use the Site in any way that violates U.S. laws</li>
            <li>Will provide accurate details when interacting with the Site</li>
            <li>Are fully responsible for all activity under your account</li>
          </ul>

          <h2 className="text-2xl font-heading font-bold text-brand-navy mt-8 mb-4">
            Disclaimers and Limitations
          </h2>
          <p className="font-bold">
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE DISCLAIM ANY WARRANTIES THAT THE WEBSITE AND SERVICES ARE MERCHANTABLE, ACCURATE, OR FIT FOR A PARTICULAR PURPOSE.
          </p>

          <h2 className="text-2xl font-heading font-bold text-brand-navy mt-8 mb-4">
            Arbitration
          </h2>
          <p>
            Any disputes shall be resolved by binding arbitration. <strong>NO CLASS ACTIONS SHALL BE ALLOWABLE.</strong>
          </p>

          <h2 className="text-2xl font-heading font-bold text-brand-navy mt-8 mb-4">
            Contact Information
          </h2>
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 space-y-3">
            <div>
              <p><strong>Company:</strong> US Brand Experts</p>
              <p><strong>Address:</strong> 1300 S Grand Ave Building A</p>
              <p className="ml-16">Santa Ana, CA 92705</p>
            </div>
            <div>
              <p><strong>Phone:</strong> +1 (877) 638-0328</p>
              <p><strong>Email:</strong> info@usbrandexperts.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
